import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import {
  DeleteIcon,
  EditIcon,
  EyeOpened,
  GrayDownloadIcon,
} from "../../../styled/AllImages";
import DeleteModal from "../../../admin/Modals/DeleteModal/DeleteModal";
import { useState } from "react";

const DynamicTableActionBtns = ({
  row,
  onEdit,
  onDelete,
  onOpen,
  onViewDetails,
  onStatusToggle,
  status,
  options,
  onInfoView,
  tooltipData,
  updateVisibilityStatus,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  const handleDelete = () => {
    onDelete();
    setShowModal(false);
  };

  return (
    <div className="action-buttons">
      {/* {filteredOptions &&
        filteredOptions.includes("open") &&
        getModuleOperations(cabinetTypeId, 3) && (
          <button
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("open")}
            onClick={onOpen}
          >
            {t("open")}
          </button>
        )} */}

      {/* {filteredOptions && filteredOptions.includes("tooltip") && (
        <TooltipInfo data={tooltipData} />
      )}

      {filteredOptions && filteredOptions.includes("tooltip2") && department && (
        <ProfileTooltip
          data={departmentInfo}
          userName={department.userName}
          userRole={department.userRole}
          userImage={department.userImage}
        />
      )} */}

      {options && options.includes("view") && (
        <span
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("view_details")}
          onClick={onOpen && onOpen}
        >
          <EyeOpened />
        </span>
      )}

      {options && options.includes("download") && (
        <span
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("download")}
        >
          <GrayDownloadIcon />
        </span>
      )}

      {/* {filteredOptions &&
        filteredOptions.includes("info") &&
        getModuleOperations(typeId, 5) && (
          <span
            className="default-icon"
            data-tooltip-id="action-tooltip"
            data-tooltip-content={t("history")}
            onClick={() => onInfoView(row)}
          >
            <NewHistoryIcon />
          </span>
        )} */}

      {options && options.includes("edit") && (
        <span
          // onClick={() => onEdit(row)}
          onClick={onEdit && onEdit}
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("edit")}
        >
          <EditIcon />
        </span>
      )}

      {/* {filteredOptions && filteredOptions.includes("transfer") && (
        <span
          className="default-icon"
          onClick={onTransfer}
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("transfer")}
        >
          <ReverseArrows />
        </span>
      )} */}

      {options && options.includes("status") && (
        <div
          className={`switch ${parseInt(row.status) === 1 ? "active" : ""}`}
          onClick={onStatusToggle && onStatusToggle}
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("status")}
        >
          <span className="slider" />
        </div>
      )}

      {options && options.includes("delete") && (
        <span
          onClick={() => setShowModal(true)}
          className="default-icon"
          data-tooltip-id="action-tooltip"
          data-tooltip-content={t("delete")}
        >
          <DeleteIcon />
        </span>
      )}
      <Tooltip
        id="action-tooltip"
        place="top"
        style={{
          backgroundColor: "#333",
          color: "#fff",
          fontSize: "12px",
          borderRadius: "6px",
          padding: "6px 10px",
        }}
      />
      <DeleteModal
        show={showModal}
        onHide={handleDelete}
        title={t("product")}
        onDelete={onDelete}
      />
    </div>
  );
};

export default DynamicTableActionBtns;
